import type { AsyncBelongsTo } from "@ember-data/model";
import Model, { attr, belongsTo } from "@ember-data/model";
import type FileContent from "parog-web/models/file-content";
import type Patient from "parog-web/models/patient";
import type JournalEvent from "./journal-event";

export default class FileAttachment extends Model {
  @belongsTo("file-content", {
    async: true,
    inverse: "fileAttachment"
  })
  declare fileContent: AsyncBelongsTo<FileContent>;
  @attr("string") declare filename: string;
  @attr("number") declare index: number;
  @belongsTo("journal-event", {
    polymorphic: true,
    async: true,
    inverse: "fileAttachments"
  })
  declare journalEvent: AsyncBelongsTo<JournalEvent>;
  @attr("string") declare mimeType: string;
  @belongsTo("patient", {
    async: false,
    inverse: "fileAttachments"
  })
  declare patient: Patient | null;
  @attr("string") declare url: string | undefined;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "file-attachment": FileAttachment;
  }
}
